import axios from "axios";

/**
 * Разбор ошибок HTTP.
 *
 * До этого во всех обработчиках стояло `catch (error)` с последующим
 * `error.response.data`. any отключает проверку целиком: опечатка в цепочке
 * свойств не ловилась, а если приходило не axios-исключение, обращение
 * к response падало уже внутри catch.
 */

/** Тело ответа с ошибками валидации: поле -> текст или список текстов. */
export type ServerErrorData = Record<string, unknown>;

/**
 * Возвращает тело ответа сервера, если исключение пришло от axios
 * и содержит данные. Иначе null — значит ошибка не серверная
 * (сеть, отмена запроса, ошибка в самом коде).
 */
export const getServerErrorData = (error: unknown): ServerErrorData | null => {
  if (!axios.isAxiosError(error)) {
    return null;
  }
  const data = error.response?.data;
  if (!data || typeof data !== "object") {
    return null;
  }
  return data as ServerErrorData;
};

/** HTTP-код ответа, если он есть. */
export const getStatusCode = (error: unknown): number | null =>
  axios.isAxiosError(error) ? error.response?.status ?? null : null;
